var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { InputContainer, InputIcon, InputSpinner, InputWrapper } from './styles/input.styled';
export const Input = forwardRef(function InputWithForwardRef(_a, ref) {
    var { reference, required, disabled, valid, loading, variant = 'field-text', left, right, colorContext = 'on-light', color, onFocus, onBlur, noWrapper = false } = _a, props = __rest(_a, ["reference", "required", "disabled", "valid", "loading", "variant", "left", "right", "colorContext", "color", "onFocus", "onBlur", "noWrapper"]);
    /**
     * The legacy FormFieldLicensePlate component uses FormInput to render an input field. Ideally it should just use an
     * input element, but it needs all the form handling/validation of the  FormInput component.
     * Therefore, we need to check if this component is used for a license plate input field, and if so, we should not
     * wrap it.
     */
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => inputRef.current, [inputRef]);
    const handleFocus = (event) => {
        var _a;
        (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('focus');
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    };
    const handleBlur = (event) => {
        var _a;
        (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove('focus');
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    };
    const handleClick = () => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const input = (_jsx(InputContainer, Object.assign({ id: reference, required: required, disabled: disabled, "aria-required": required, "aria-disabled": disabled }, (valid === false && { 'aria-invalid': true }), { "data-hj-suppress": true, inputRef: inputRef, variant: variant, onFocus: handleFocus, onBlur: handleBlur }, props)));
    if (noWrapper) {
        return input;
    }
    return (_jsxs(InputWrapper, { "$colorContext": colorContext, "$color": color, "$invalid": valid === false, "$disabled": disabled === true, ref: wrapperRef, className: disabled ? 'disabled' : '', onClick: handleClick, children: [left, input, loading && _jsx(InputSpinner, {}), !loading && right, !loading && !right && (valid === false || color === 'error') && (_jsx(InputIcon, { "$color": "error", "$disabled": disabled === true, variant: "error" })), !loading && !right && color === 'success' && (_jsx(InputIcon, { "$color": "success", "$disabled": disabled === true, variant: "check-usp" }))] }));
});
